import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "1em",
        color: "white",
        padding: "15px",
        backgroundColor: "#223D6C", // Set background color if needed
        // border: '1px solid red',
        fontSize: "14px",
        marginTop: "-10px",
      }}
    >
      <div>
        &copy;{currentYear} InvesTek.in. All rights reserved. Ver 2.0.0.
      </div>
      <div>Terms & Conditions &#x25cf; Privacy Policy</div>
    </div>
  );
};

export default Footer;
